import { View, ViewStyle } from "react-native";
import { Text } from "react-native-paper";
import { DocumentPickerAsset } from "expo-document-picker";
import { FieldError } from "react-hook-form";
import Feather from "@expo/vector-icons/Feather";

import { Button } from "../../components";
import { colors } from "../../../theme";

interface NoDocumentSelectedProps {
  label: string;
  handleSelectFile(onChange: (value: DocumentPickerAsset) => void): () => void;
  onChange(value: DocumentPickerAsset): void;
  error?: FieldError;
  style?: ViewStyle; // required for dividers
}

const NoDocumentSelected = ({ label, error, handleSelectFile, onChange, style }: NoDocumentSelectedProps) => {
  return (
    <View className="flex-row items-center w-full py-4 px-6" {...{ style }}>
      <View className="flex-row justify-between items-center flex-grow">
        <View>
          <Text className="text-regular-tight font-500 text-ink-darkest">{label}</Text>
          {error && <Text className="text-small-tight font-400 text-red-darkest">{error.message}</Text>}
        </View>
        <Button mode="secondary" labelStyle="mx-4 my-2" onPress={handleSelectFile(onChange)} testID="job-apply-upload-button">
          <Text className="text-regular-normal font-500 text-primary">Upload</Text>
          <View className="w-2.5" />
          <Feather name="upload" size={16} color={colors.primary.DEFAULT} />
        </Button>
      </View>
    </View>
  );
};

export default NoDocumentSelected;
